import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getUserData, loginUser, registerUser } from "../Api/customer";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../components/Loader";

export default function Signup({ onRegisterUser }) {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate('');

    const slides = [
        {
            image: <img src={require('../images/guest_login.png')} alt="guest_login" />,
            text: "Save Big on Your Medicines",
            subtext: "Save up to 80% on WHO standard medicines"
        },
        {
            image: <img src={require('../images/login.png')} alt="login" />,
            text: "Know Your Medicines",
            subtext: "View medicine information like: Dosage, Side Effects and cheaper substitute products available."
        },
        {
            image: <img src={require('../images/signup.png')} alt="signup" />,
            text: "Get Expert Advice",
            subtext: "Login/signup to have Expert Advice,Health Tips and much more."
        }
    ];

    const [currentSlide, setCurrentSlide] = React.useState(0);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    React.useEffect(() => {
        const interval = setInterval(nextSlide, 3000);
        return () => clearInterval(interval);
    }, []);

    async function userSignin(e) {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await registerUser({
                email: email,
                username: username,
                name: name,
                password: password,
                role: 'customer'
            })
            console.log(response);

            if(response.status===201){
                const response = await loginUser({
                    username: username,
                    password: password
                })
                localStorage.setItem("auth_token", response.token)
            }
            
            const token = localStorage.getItem("auth_token")
            // get user data
            const loggedInUserData = {}
            const userData = await getUserData(token)
            loggedInUserData.isSuperAdmin = userData.is_super_admin
            loggedInUserData.id = userData.id
            loggedInUserData.name = userData.name
            loggedInUserData.email = response.user_email
            loggedInUserData.username = response.user_nicename
            localStorage.setItem("user_data", JSON.stringify(loggedInUserData))

            setName('');
            setEmail('');
            setUsername('');
            setPassword('');
            setLoading(false);
            navigate('/');
            onRegisterUser(response);
        } catch (error) {
            console.log(error);
            setLoading(false);
            // Show the server's reason — "That username is taken" or "Password must be
            // at least 8 characters" tells the user what to change; "Something went
            // wrong" leaves them stuck retrying the same thing.
            toast.error(error.message || "Something went wrong!");
        }
    }

    return (
        <>
            <ToastContainer />
            {
                loading === true ? (<Loader />) : (<>
                    <div className="content-wrapper">
                        <div className="wrapper signUp" style={{ width: "100%" }}>
                            <div className="small-container d-flex" style={{ justifyContent: "space-around" }}>
                                <div className="login-carousel">
                                    <div className="login-carousel-inner" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                                        {slides.map((slide, index) => (
                                            <div className="login-carousel-item" key={index}>
                                                {slide.image}
                                                <h2>{slide.text}</h2>
                                                <p>{slide.subtext}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="login-dots">
                                        {slides.map((_, index) => (
                                            <span
                                                key={index}
                                                className={`login-dot ${index === currentSlide ? 'active' : ''}`}
                                                onClick={() => goToSlide(index)}
                                            ></span>
                                        ))}
                                    </div>
                                </div>
                                <hr style={{ height: "450px" }} />
                                <div className="form" onSubmit={userSignin}>
                                    <div className="heading">CREATE AN ACCOUNT</div>
                                    <form>
                                        <div>
                                            <label htmlFor="name">Name</label>
                                            <input type="text" id="name" placeholder="Enter your name" onChange={(e) => setName(e.target.value)} />
                                        </div>
                                        <div>
                                            <label htmlFor="email">E-Mail</label>
                                            <input type="email" id="email" placeholder="Enter your mail" onChange={(e) => setEmail(e.target.value)} />
                                        </div>
                                        <div>
                                            <label htmlFor="username">Username</label>
                                            <input type="text" id="username" placeholder="Enter your username" onChange={(e) => setUsername(e.target.value)} />
                                        </div>
                                        <div>
                                            <label htmlFor="password">Password</label>
                                            <input
                                                type="password"
                                                id="password"
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder="Enter you password"
                                            />
                                        </div>
                                        <button type="submit">Submit</button>
                                        <h2 align="center" className="or">
                                            OR
                                        </h2>
                                    </form>
                                    <p>
                                        Have an account ? <Link to="/login"> Login </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>)
            }
        </>
    );
}
